import React, { useCallback, useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import styles from "./DocumentsLiveMode.module.css";
import { NetworkConfig } from "src/network/NetworkConfig";
import { ColorStyle } from "src/utils/Colors";

const DocumentsLiveModeBase = observer(() => {
    const { agendaitemStore } = useContext(RootStoreContext);
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const onClickTitleRow = useCallback(() => {
        setIsExpanded((prev) => !prev);
    }, []);

    const agendaitemfiles = agendaitemStore.currentAgendaItem?.agendaitemfiles;

    const handleStopPropagation = useCallback<React.MouseEventHandler<HTMLAnchorElement>>((e) => {
        e.stopPropagation();
    }, []);

    return (
        <UI.Card className={styles.Card}>
            <div className={styles.CardContent}>
                <div className={styles.TitleRow} onClick={onClickTitleRow}>
                    <div className={styles.Title}>{t("screens.realestate.assembly.documents")}</div>
                    {agendaitemfiles && agendaitemfiles.length > 3 ? (
                        <UI.Icon
                            icon={isExpanded ? UI.SVGIcon.ChevronUp : UI.SVGIcon.ChevronDown}
                            className={styles.IconChevronDown}
                            size={24}
                        />
                    ) : undefined}
                </div>
                <div>
                    {agendaitemfiles && agendaitemfiles.length > 0 ? (
                        <>
                            {(isExpanded ? agendaitemfiles : agendaitemfiles.slice(0, 3)).map((agendaItemFile) => {
                                const assemblyFileLink = NetworkConfig.datafileUrl + agendaItemFile.fileid;
                                return (
                                    <a
                                        key={agendaItemFile.fileid}
                                        href={assemblyFileLink}
                                        className={`${styles.DocumentLinkContainer} link`}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        onClick={handleStopPropagation}
                                    >
                                        <UI.Icon
                                            className={styles.DocumentIcon}
                                            icon={UI.SVGIcon.Documents}
                                            color={ColorStyle("primary")}
                                            size={30}
                                        />
                                        <div className={styles.FileName}>{agendaItemFile.name}</div>
                                    </a>
                                );
                            })}
                        </>
                    ) : undefined}
                </div>
            </div>
        </UI.Card>
    );
});

export const DocumentsLiveMode = Sentry.withProfiler(DocumentsLiveModeBase);
